import React, { Fragment } from "react";
import { Col, Accordion } from "react-bootstrap";

import CircleHands from "../../assets/imgCultura.png";

const RazonOcho = () => {
  return (
    <Fragment>
      <Col
        lg={6}
        className="contentCards cardLigth "
        id="razonOcho"
        data-aos="fade-right"
        data-aos-offset="300"
        data-aos-duration="1000"
        data-aos-easing="ease-out"
      >
        <div className="contentCardsInferiores">
          <h4>Razón #8</h4>
          <h2
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-duration="500"
          >
            Cultura organizacional
          </h2>
          <p
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-duration="500"
          >
            320 colaboradores aportando con orgullo y dedicación, distintas
            especialidades para crear un producto que cumpla el sueño de
            nuestros clientes.
          </p>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Ver más</Accordion.Header>
              <Accordion.Body>
                <p className="textoCalidad">
                  IPC Pools ha logrado construir una cultura organizacional que
                  hoy integran más de 320 colaboradores junto a una red de
                  concesionarios, clientes, proveedores y comunidad. Valoramos
                  el esfuerzo, la constancia, y todo el talento que encontramos
                  en nuestro capital humano, que hacen posible un importante
                  desarrollo técnico y profesional desde nuestra planta en
                  Mendoza y en toda Argentina. Nuestros especialistas trabajan
                  en diseño e innovación para crear la piscina que es tendencia
                  en el mercado. Desde mantenimiento se opera en todas las áreas
                  para prolongar la vida de los equipos y tener la línea a punto
                  para su mayor eficiencia. En compras, los expertos adquieren
                  materia prima de calidad que asegure el estándar de todos
                  nuestros productos, desde el primer eslabón de su fabricación.
                  Con el compromiso de proveer a toda la Red de 80
                  Concesionarios en el país, el sector de logística entrega
                  eficientemente cada producto en forma segura.
                </p>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>

        <img
          src={CircleHands}
          alt="Cultura Organizacional"
          className="w-100"
          data-aos="fade-up"
          data-aos-offset="300"
          data-aos-duration="500"
        ></img>
      </Col>
    </Fragment>
  );
};

export default RazonOcho;
